import React, { useRef } from "react";
import { motion } from "framer-motion";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { Icon } from "../Icon";
import { SOLVE } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const Card = ({ card, index }) => {
  const { t } = useLang();
  const ref = useRef(null);
  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    ref.current.style.setProperty("--mx", `${e.clientX - r.left}px`);
    ref.current.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <Reveal delay={(index % 3) * 0.08} className="h-full">
      <div
        ref={ref}
        onMouseMove={onMove}
        data-testid={`solve-card-${index}`}
        className="group relative h-full overflow-hidden rounded-2xl border border-white/[0.07] bg-[#0A0E17] p-8 transition-colors duration-500 hover:border-[#3B82F6]/40"
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
          style={{ background: "radial-gradient(340px circle at var(--mx) var(--my), rgba(59,130,246,0.12), transparent 60%)" }}
        />
        <div className="relative flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-[#60A5FA] transition-all duration-500 group-hover:border-[#3B82F6]/50 group-hover:text-white group-hover:shadow-[0_0_24px_rgba(59,130,246,0.35)]">
          <Icon name={card.icon} className="h-5 w-5" />
        </div>
        <h3 className="relative mt-6 text-xl font-medium tracking-tight text-white leading-snug">{t(card.title)}</h3>
        <p className="relative mt-3.5 text-sm leading-relaxed text-white/55">{t(card.text)}</p>
      </div>
    </Reveal>
  );
};

export const WhatWeSolve = () => {
  const { t } = useLang();
  return (
    <section id="solve" data-testid="solve-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading overline={t(SOLVE.overline)} title={t(SOLVE.title)} />
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SOLVE.cards.map((card, i) => (
            <Card key={i} card={card} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
